module.exports = {

    Auth: {
        Can: require("./auth/Can"),
        Session: require("./auth/Session"),
    },

    Errors: {
        Boundary: require("./errors/Boundary")
    },

    Providers: require("./providers"),

    Decorators: {
        Injector: require("./decorators/Injector")
    },

    Triggers: require("./triggers"),

};